import { APIResponse, APIResponseDtoImpl } from '../../apiresponse';

export interface DeleteToneResponse extends APIResponse
{

}

export class DeleteToneResponseDtoImpl extends APIResponseDtoImpl implements DeleteToneResponse
{
   
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/tune/deletetone/deletetoneresponse.tsx